import { schema } from 'normalizr';

export const lockSpecSchema = new schema.Entity(
  'lockSpecs',
  {},
  {
    idAttribute: 'uuid',
  },
);
